import SimpleBar from "simplebar-react";
import React, { useState, useEffect } from "react";
import MainLink from "../../Link";

const ucp_get_items = `${MainLink()}api/ucp/get-shop-items`;
const ucp_get_favorites = `${MainLink()}api/ucp/get-favourite-items`;
const ucp_put_in_favourites = `${MainLink()}api/ucp/put-in-favourites`;
const ucp_delete_from_favourites =`${MainLink()}api/ucp/delete-from-favourites`;

function ShopFavoritesList() {
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const [items, setItems] = useState([]);
    const [favorites, setFavorites] = useState(new Set());
    const [loading, setLoading] = useState("Загрузка....");
    const [favoriteItems, setFavoriteItems] = useState([]);

    const fetchFavorites = async () => {
        try {
            const userId = localStorage.getItem("user-id");
            const userName = localStorage.getItem("user-login");
            const userPassword = localStorage.getItem("user-password");

            const urlWithParams = `${ucp_get_favorites}?user_id=${encodeURIComponent(userId)}&user_name=${encodeURIComponent(userName)}&user_password=${encodeURIComponent(userPassword)}`;
            const response = await fetch(urlWithParams, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem("jwtToken")}`
                },
            });

            if (!response.ok) {
                throw new Error(`Ошибка загрузки избранных предметов: ${response.status}`);
            }

            const favItems = await response.json();
            setFavoriteItems(favItems);
            setFavorites(new Set(favItems));




        } catch (err) {
            console.error("Ошибка загрузки данных:", err.message);
            setLoading("Не найдено товаров в избранном.");
        }
    };

    const setOutputItems = async () => {
        const allItemsResponse = await fetch(ucp_get_items, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${localStorage.getItem("jwtToken")}`
            },
        });

        if (!allItemsResponse.ok) {
            throw new Error(`Ошибка загрузки всех предметов: ${allItemsResponse.status}`);
        }

        const allItems = await allItemsResponse.json();
        const filteredItems = allItems.filter(item => {
            const isFavorite = favoriteItems.some(favItem => favItem === item.id);

            return isFavorite;
        });
        setItems(filteredItems);

    }

    useEffect(() => {
        fetchFavorites();
    }, []);

    useEffect(() => {
        setFavorites(new Set(favoriteItems));
        setOutputItems();
        console.log("items fff: ", items);
    }, [favoriteItems]);

    useEffect(() => {
        console.log("log");
        if(items.length < 1) {
            setLoading("Не найдено товаров в избранном.")
        }
    }, [favorites]);

    const handleBuyItem = async (item) => {
        const userId = localStorage.getItem("user-id");
        const userName = localStorage.getItem("user-login");
        const userPassword = localStorage.getItem("user-password");

        window.location.href = "/shop/buy?item_id=" + encodeURIComponent(item.id);

    };
    const [activeIndex, setActiveIndex] = useState([]);

    const toggleFavorite = async (itemId, index) => {
        const userId = localStorage.getItem("user-id");
        const userName = localStorage.getItem("user-login");
        const userPassword = localStorage.getItem("user-password");
        let activeIndexes = activeIndex;
        activeIndexes.push(index);
        setActiveIndex(activeIndexes);

        const body = {
            user_id: userId,
            user_name: userName,
            user_password: userPassword,
            item_id: itemId
        };

        try {
            if (favorites.has(itemId)) {
                const response = await fetch(ucp_delete_from_favourites, {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${localStorage.getItem("jwtToken")}`
                    },
                    body: JSON.stringify(body)
                });

                if (!response.ok) {
                    throw new Error(`Ошибка при удалении из избранного: ${response.status}`);
                }

                const result = await response.json();
                if(result) {
                    console.log("favorites: ", favorites);
                    console.log("items: ", items)
                    favorites.delete(itemId);
                    const updatedItems = items.filter(item => item.id !== itemId);
                    setItems(updatedItems);
                    console.log("items posle:", items);
                }
            }

            // Обновление состояния избранных предметов


        } catch (err) {
            console.error("Ошибка при обновлении избранного:", err.message);
        }
    };

    console.log("::::",items)
    return (
        <SimpleBar className="simplebar-track-shop" style={{ overflowY: "auto" }}>
            <div className="ucp-two-blocks-container ucp-two-blocks-container-shop">
                {
                    items.length > 0 || !loading ? (
                    items.map((item, index) => (
                        <div
                            key={index}
                            className="character-body character-body-shop"
                            onMouseEnter={() => setHoveredIndex(index)}
                            onMouseLeave={() => setHoveredIndex(null)}
                        >
                            <div className="character-body information-container-body-shop">
                                <img src={"/media/" + item.imgUrl} alt=""/>
                                <button
                                    className={`ucp-button favorites-button ${"active"}`}
                                    onClick={() => toggleFavorite(item.id, index)}
                                >
                                    {favorites.has(item.id)}
                                </button>
                            </div>
                            <span className="character-description">
                                    {item.name}
                                </span>
                                <button
                                    className="ucp-simple-yellow-button character-description-button"
                                    type="button"
                                    onClick={() => handleBuyItem(item)}
                                >
                                        {hoveredIndex === index ? "КУПИТЬ" : `${item.price} MD`}
                                    </button>
                        </div>
                    ))
                ) : (
                    <p className="loading-text">{loading}</p>)}
            </div>
        </SimpleBar>
    );
}

export default ShopFavoritesList;